import React, { Component } from 'react';
import {
	createStore, applyMiddleware, compose, combineReducers,
} from 'redux';
//import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import App from './App';
import introStepReducer from './store/reducers/introStep';
import appReducer from './store/reducers/app';


const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
	introStep: introStepReducer,
	app: appReducer,
});


const store = createStore(rootReducer, composeEnhancers(
	applyMiddleware(thunk),
));

/*
const store = configureStore({
	reducer: {
		introStep: introStepReducer,
		app: appReducer
	}
});*/

export default class Index extends Component {
	render() {
		return (
			<Provider store={store}>
				<App {...this.props} />
			</Provider>
		);
	}
}
